import { create } from 'zustand';

import type { AccountStatsRow } from '../types/account-stats';

type GeneralStatsCacheState = {
  cacheKey: string | null;
  rows: AccountStatsRow[];
  setCache: (key: string, rows: AccountStatsRow[]) => void;
};

export const useGeneralStatsCache = create<GeneralStatsCacheState>((set) => ({
  cacheKey: null,
  rows: [],
  setCache: (key, rows) => set({ cacheKey: key, rows }),
}));
